import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="privacyPolicyPage" data-testid="privacyPolicyPage" />
  );
};

export default PrivacyPolicy;
